/* SÁRO cart — plays the champagne shimmer once, at the moment the order crosses the free shipping amount.
   Watches the free shipping bar (sv-cart.js sets .is-done on it) and adds .is-celebrate for a few seconds.
   It doesn't play when the cart is opened already over the amount, only when it crosses it.
   To preview it any time, add ?sv_shimmer=1 to the page address and open the cart. */
(function () {
  'use strict';
  if (window.SVShimmerLoaded) return;
  window.SVShimmerLoaded = true;

  var PLAY_MS = 4200;

  function start() {
    var ship = document.querySelector('#CartDrawer [data-sv-ship]');
    if (!ship) return;
    var armed = false; // true once we've seen the bar showing and not yet unlocked
    var timer = null;

    function celebrate() {
      ship.classList.remove('is-celebrate');
      void ship.offsetWidth; // restart the animation
      ship.classList.add('is-celebrate');
      clearTimeout(timer);
      timer = setTimeout(function () { ship.classList.remove('is-celebrate'); }, PLAY_MS);
    }
    window.svCelebrate = celebrate;

    function check() {
      var visible = !ship.hidden;
      var done = ship.classList.contains('is-done');
      if (visible && !done) { armed = true; return; }
      if (visible && done && armed) { armed = false; celebrate(); }
      if (!visible) armed = false;
    }

    new MutationObserver(check).observe(ship, { attributes: true, attributeFilter: ['class', 'hidden'] });

    // Preview helper: ?sv_shimmer=1 plays it every time the cart opens
    if (/[?&]sv_shimmer=1/.test(location.search)) {
      document.addEventListener('click', function (e) {
        if (e.target.closest('.js-drawer-open-cart')) setTimeout(function () { if (!ship.hidden) celebrate(); }, 500);
      });
      document.addEventListener('ajaxProduct:added', function () { setTimeout(function () { if (!ship.hidden) celebrate(); }, 900); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
